import CelebrationIcon from '@assets/icons/CelebrationIcon'
import { colors } from '@globals/themes/defaultTheme'
import { CalendarEvent } from '@kudos/http-client'
import { Stack, Typography } from '@mui/material'
import UserAvatar from '@shared/avatar/UserAvatar'
import CelebrationGreeting from '@shared/celebrations/CelebrationGreeting'
import { format, parseISO } from 'date-fns'
import KudosTvCard from '../KudosTvCard'

type TvCelebrationProps = {
  celebration: CalendarEvent
}

const TvCelebration: React.FC<TvCelebrationProps> = ({ celebration }) => {
  const { memberDisplayData, celebratedOn, type } = celebration
  return (
    <KudosTvCard
      primaryColor={colors.aquaPrimary}
      icon={<CelebrationIcon />}
      postContent={
        <Stack height="inherit" justifyContent="center" alignItems="center">
          <UserAvatar
            size={180}
            firstName={memberDisplayData?.firstName}
            lastName={memberDisplayData?.lastName}
            media={memberDisplayData?.avatarUrls}
          />
          <Typography variant="h1">
            <CelebrationGreeting memberDisplayData={memberDisplayData} celebrationType={type} />
          </Typography>
          {memberDisplayData?.jobTitle && (
            <Typography variant="caption" fontSize="2rem">
              {memberDisplayData?.jobTitle}
            </Typography>
          )}
          <Typography variant="body1" fontSize="2rem" mt={2}>
            {format(parseISO(celebratedOn), 'MMMM dd, yyyy')}
          </Typography>
        </Stack>
      }
    />
  )
}

export default TvCelebration
